export const getIcon = (type) => {
    switch(type) {
        case 'page': return 'fal fa-file';
        case 'module': return 'fal fa-copy';
        case 'elearning': return 'fal fa-cubes';
        default: return 'fal fa-question';
    }
}

